<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", [
    _c(
      "div",
      { staticClass: "order-created" },
      [
        _c("div", { staticClass: "download-order-report" }, [
          _c("div", { staticClass: "d-flex mb-1" }, [
            _c(
              "h3",
              { staticClass: "mb-0 back_button" },
              [
                _c("BackButton"),
                _c("span", [_vm._v(_vm._s(_vm.$t("adsOrder.Ad-Order")))]),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "pl-2--row" },
          [
            !_vm.adDetails
              ? _c("b-row", { staticClass: "mt-2 no-record-found-text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("adsOrder.RecordNotFound")) + " "),
                ])
              : _c(
                  "b-row",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-card",
                      { staticClass: "border w-100 ad-order-page" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "right-20",
                                attrs: { sm: "12", md: "6", lg: "6" },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("adsOrder.Ad-Id")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(_vm._s(_vm.adDetails.id)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("adsOrder.Type")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(
                                            _vm._s(_vm.adDetails.orderType)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("adsOrder.Coin")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(_vm._s(_vm.adDetails.coin)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("adsOrder.Fiat")) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(_vm._s(_vm.adDetails.fiat)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              {
                                staticClass: "left-20",
                                attrs: { sm: "12", md: "6", lg: "6" },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("adsOrder.Trade-QTY")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.tradQuantity +
                                                  "/" +
                                                  _vm.adDetails.totalQuantity +
                                                  " "
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("adsOrder.Order-Limit")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.adDetails
                                                  .minOrderPriceLimit +
                                                  " - " +
                                                  _vm.adDetails
                                                    .maxOrderPriceLimit
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("adsOrder.Create-Time")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.convertDate(
                                                  _vm.adDetails.createdTime
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-1" },
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "8", md: "8", lg: "8" } },
                                      [
                                        _c("div", { staticClass: "add-text" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("adsOrder.Status")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "4", md: "4", lg: "4" } },
                                      [
                                        _c("div", { staticClass: "add-amt" }, [
                                          _vm._v(
                                            _vm._s(_vm.adDetails.adStatus)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
        _vm.adDetails
          ? _c("b-table", {
              staticClass: "mt-2",
              attrs: { items: _vm.items, fields: _vm.fields, responsive: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "cell(createdTime)",
                    fn: function (data) {
                      return [_vm._v(" " + _vm._s(_vm.convertDate(data.value)))]
                    },
                  },
                ],
                null,
                false,
                2273151714
              ),
            })
          : _vm._e(),
        _c(
          "b-row",
          [
            _c(
              "b-col",
              {
                staticClass:
                  "d-flex align-items-center justify-content-center justify-content-sm-end",
                attrs: { cols: "12", sm: "12" },
              },
              [
                _vm.isPaginationVisible
                  ? _c("b-pagination", {
                      key: _vm.page,
                      staticClass: "mb-0 mt-1 mt-sm-0",
                      attrs: {
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.size,
                        "first-number": "",
                        "last-number": "",
                        "prev-class": "prev-item",
                        "next-class": "next-item",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prev-text",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  attrs: {
                                    icon: "ChevronLeftIcon",
                                    size: "18",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "next-text",
                            fn: function () {
                              return [
                                _c("feather-icon", {
                                  attrs: {
                                    icon: "ChevronRightIcon",
                                    size: "18",
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1308952388
                      ),
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/myads/adsOrder.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_ads_actions_svg from '@/assets/rashi-coin/ads-actions.svg';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import moment from 'moment';
import utils_constants from '@/utils/constants';
import * as vuex from 'vuex';
import layouts_components_BackButton_vue from '@/layouts/components/BackButton.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BAvatar: bootstrapvue["BAvatar"],
    vSelect: vue_select,
    AdsActions: assets_rashi_coin_ads_actions_svg,
    BPagination: bootstrapvue["BPagination"],
    BackButton: layouts_components_BackButton_vue
  },
  computed: {
    ...vuex.mapState("user", ["refData"])
  },
  data() {
    return {
      AddPayment: false,
      fields: [{
        key: "id",
        label: this.$t("adsOrder.OrderId"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "sellerPaymentMethodInfo.paymentMethod",
        label: this.$t("adsOrder.PaymentMethod"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "rate",
        label: this.$t("adsOrder.Price"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalQuantity",
        label: this.$t("adsOrder.Quantity"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "totalAmount",
        label: this.$t("adsOrder.Amount"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "createdTime",
        label: this.$t("Order.CreateTime"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }, {
        key: "orderStatus",
        label: this.$t("adsOrder.Status"),
        tdClass: "n-wrap",
        thClass: "n-wrap"
      }],
      items: [],
      adDetails: null,
      page: 1,
      size: 10,
      isPaginationVisible: false,
      totalRows: 0,
      tradQuantity: 0
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAdDetails();
      if (this.$route && this.$route.query && this.$route.query.page) {
        this.page = this.$route.query.page;
      } else {
        this.getAdDetailsTable();
      }
    } else {
      this.$router.go(-1);
    }
  },
  watch: {
    size() {
      if (!this.size) {
        this.size = 10;
      }
      this.getAdDetailsTable();
    },
    page() {
      utils_constants["setPagination"].apply(this, [`${this.page}`]);
      this.getAdDetailsTable();
    }
  },
  methods: {
    convertDate(date) {
      if (!date) return "";
      const str = String(date);
      if (moment(str, moment.ISO_8601, true).isValid()) {
        return moment(str).format("DD/MM/YYYY HH:mm");
      }
      const withZ = (str.endsWith("Z") || str.includes("+")) ? str : `${str}Z`;
      if (moment(withZ, moment.ISO_8601, true).isValid()) {
        return moment(withZ).format("DD/MM/YYYY HH:mm");
      }
      if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YYYY HH:mm");
      }
      return date;
    },
    async getAdDetails() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/ad/get/${this.$route.params.id}`
        }, {}, {
          isLoading: true
        });
        if (res && res.ad) {
          this.adDetails = res.ad;
          this.tradQuantity = parseFloat((this.adDetails.totalQuantity - (this.adDetails.availableQuantity + this.adDetails.reserveQuantity)).toFixed(this.refData.coinDecimal || utils_constants["coinDecimal"]));
        } else if (res && res.error && res.error.message) {
          this.adDetails = null;
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getAdDetailsTable() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/ad/orders/${this.$route.params.id}`
        }, {
          page: this.page,
          size: this.size
        }, {
          isLoading: true
        });
        if (res && res.orders) {
          this.items = res.orders;
          this.totalRows = res.count;
          if (res.count && res.count > this.size) {
            this.isPaginationVisible = true;
          } else {
            this.isPaginationVisible = false;
          }
        } else if (res && res.error && res.error.message) {
          this.items = [];
          this.totalRows = 0;
          this.isPaginationVisible = false;
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/myads/adsOrder.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.download-order-report {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.add-amt {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}
[dir=ltr] .add-amt {
  text-align: right;
}
[dir=rtl] .add-amt {
  text-align: left;
}
.add-text {
  color: #949191;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}
[dir=ltr] .left-20 {
  padding-left: 25px;
}
[dir=rtl] .left-20 {
  padding-right: 25px;
}
[dir=ltr] .right-20 {
  border-right: 1px solid #ebe9f1;
  padding-right: 25px;
}
[dir=rtl] .right-20 {
  border-left: 1px solid #ebe9f1;
  padding-left: 25px;
}
.no-record-found-text {
  display: flex;
  min-height: 60vh;
  align-items: center;
  justify-content: center;
}
</style>
